import { render, staticRenderFns } from "./LinkInputModal.vue?vue&type=template&id=2740484c"
import script from "./LinkInputModal.vue?vue&type=script&lang=js"
export * from "./LinkInputModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports